module.exports = __webpack_public_path__ + "static/media/teeksha.43ae9b86.png";